import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Card, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const LineChartComponent = ({ data, keys, type, title, loading, getLineColor }) => {
    if (loading) {
        return (
            <Card title={title}>
                <div className="flex justify-center items-center h-64">
                    <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
                </div>
            </Card>
        );
    }

    if (!data || data.length === 0) {
        return (
            <Card title={title}>
                <div className="flex justify-center items-center h-64">
                    <p>No data available for chart</p>
                </div>
            </Card>
        );
    }

    const renderTooltip = (props) => {
        const { active, payload, label } = props;
        if (active && payload && payload.length) {
            return (
                <div className="bg-white p-3 border border-gray-300 shadow-lg rounded">
                    <p className="font-medium">{`Date: ${label}`}</p>
                    {payload.map((entry, index) => (
                        <p key={index} style={{ color: entry.color }}>
                            {`${entry.dataKey}: ${entry.value}`}
                        </p>
                    ))}
                </div>
            );
        }
        return null;
    };

    return (
        <Card title={title}>
            <ResponsiveContainer width="100%" height={300}>
                <LineChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                        dataKey="date"
                        tick={{ fontSize: 12 }}
                        angle={-45}
                        textAnchor="end"
                        height={80}
                    />
                    <YAxis tick={{ fontSize: 12 }} />
                    <Tooltip content={renderTooltip} />
                    <Legend />
                    {keys.map((key, index) => (
                        <Line
                            key={key}
                            type="monotone"
                            dataKey={key}
                            stroke={getLineColor(key, index)}
                            strokeWidth={2}
                            dot={{ fill: getLineColor(key, index), strokeWidth: 2, r: 4 }}
                            activeDot={{ r: 6, fill: getLineColor(key, index) }}
                            name={key}
                        />
                    ))}
                </LineChart>
            </ResponsiveContainer>

            {/* Chart Summary */}
            <div className="mt-4 grid grid-cols-2 md:grid-cols-4 gap-2 text-xs">
                {keys.map((key, index) => (
                    <div key={key} className="flex items-center">
                        <div
                            className="w-3 h-3 rounded-full mr-2"
                            style={{ backgroundColor: getLineColor(key, index) }}
                        ></div>
                        <span>{key}: {data.reduce((sum, item) => sum + (item[key] || 0), 0)}</span>
                    </div>
                ))}
            </div>
        </Card>
    );
};

export default LineChartComponent;